import { BaseDto } from '@/shared/dtos/base-dto';

export class tipos_fichaje extends BaseDto {
    public nombre !: string;
    public festivos_convenio !: boolean;
    public festivos_empleado !: boolean;
    public color !: string; 
 } 
